/**
 * @file 首页
 */
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import { useState } from 'react';
import {
  NoticeBar,
  Banner,
  Carousel,
  Pool,
  Explore,
  Faq,
  Build,
} from '@/containers/home';
import { useStakingStore } from '@/store/staking';
import { useParams } from '@web3/base-hooks';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';
import dayjs from 'dayjs';
import { Web3SecondHeader } from '@web3fe/infra';
import { origin } from '@web3/base-utils';

import styles from './index.module.scss';
import { useEffect, useMemo } from 'react';

const STAKING_HOME_NOTICE_BAR = 'STAKING_HOME_NOTICE_BAR';
export default function Home() {
  const { locale } = useParams();
  const { getChains, getPoolInfo, getHomeConfig, homeConfig } =
    useStakingStore();
  const [noticeVisible, setNoticeVisible] = useState(false);

  const helpCenterUrl = useMemo(() => {
    return `${origin}/${locale}/help-center/article/Bybit-Web3-Staking`;
  }, [locale]);

  const handleCloseClick = () => {
    setNoticeVisible(false);
    localStorage.setItem(
      STAKING_HOME_NOTICE_BAR,
      dayjs(Date.now()).format('YYYY-MM-DD')
    );
    // 埋点
    scTrack(Event.Web3UserClick, {
      page_name: Page.StakingWebHomepage,
      button_name: 'Earn_Tips',
    });
  };

  useEffect(() => {
    const date = localStorage.getItem(STAKING_HOME_NOTICE_BAR);
    const today = dayjs(Date.now()).format('YYYY-MM-DD');
    // 未记录关闭横条的日期 或 日期有差异, 重新展示横条
    setNoticeVisible(!date || !!dayjs(date).diff(today, 'day'));

    // 埋点
    scTrack(Event.Web3PageView, {
      page_name: Page.StakingWebHomepage,
    });
  }, []);

  useEffect(() => {
    // 获取主页配置信息-不需要登录态
    getHomeConfig();
  }, [getHomeConfig]);

  useEffect(() => {
    // 获取network数据
    getChains();
  }, [getChains]);

  useEffect(() => {
    // 获取poolList数据
    getPoolInfo();
  }, [getPoolInfo]);

  return (
    <div className={styles.container}>
      <NoticeBar
        visible={noticeVisible}
        data={homeConfig?.platformNotice || ''}
        handleCloseClick={handleCloseClick}
      />
      <Web3SecondHeader />
      <Banner helpCenterUrl={helpCenterUrl} />
      <Carousel />
      <Pool />
      {/* explore Dapp */}
      <Explore />
      <div className="mt-16 flex items-stretch overflow-hidden">
        <Faq helpCenterUrl={helpCenterUrl} />
        <Build />
      </div>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage(
    'web3-staking',
    {
      locale,
      entry: import.meta.url,
      additions: ['stakingSeoTitle', 'seoKeyword', 'stakingSeoDesc'],
    },
    false
  );
  return {
    props: {
      locale,
      messages,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};
